import CheckBox from "../CheckBox/CheckBox";
import styles from "./PaymentMethodTile.module.scss";

export interface PaymentMethodTileProps {
  paymentMethodName: string;
  paymentMethodIcon: string | React.ReactNode;
  selected?: boolean;
  onSelect?: () => void;
}

function PaymentMethodTile(props: PaymentMethodTileProps) {
  const {
    paymentMethodName,
    paymentMethodIcon,
    selected = false,
    onSelect,
  } = props;
  return (
    <div
      className={`${styles.paymentMethodContainer} ${
        selected ? styles.paymentMethodContainerChecked : ""
      }`}
      onClick={onSelect}
    >
      <div className={styles.paymentMethodAndToppingWrapper}>
        <div className={styles.paymentMethodComponent}>
          <div className={styles.paymentMethodTextGroup}>
            <p
              className={`body-bold-medium ${styles.paymentMethodDescription}`}
            >
              {paymentMethodName}
            </p>
          </div>
          <div className={styles.paymentMethodTextGroup}>
            {typeof paymentMethodIcon === "string" ? (
              <i
                className={`${paymentMethodIcon} ${styles.paymentMethodIcon}`}
              />
            ) : (
              paymentMethodIcon
            )}
          </div>
        </div>
      </div>
      <div className={styles.paymentMethodSelectContainer}>
        <CheckBox checked={selected} toggleChecked={() => {}} />
      </div>
    </div>
  );
}

export default PaymentMethodTile;
